import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import NewSale from "@/pages/NewSale";
import NewExpense from "@/pages/NewExpense";
import CarTypes from "@/pages/CarTypes";
import Extras from "@/pages/Extras";
import History from "@/pages/History";
import Users from "@/pages/Users";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Cargando…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="venta" element={<NewSale />} />
            <Route path="gasto" element={<NewExpense />} />
            <Route path="autos" element={<CarTypes />} />
            <Route path="extras" element={<Extras />} />
            <Route path="historial" element={<History />} />
            <Route path="usuarios" element={<Users />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
